export default __webpack_public_path__ + "static/media/attendance_banner.e1a7a02a.png";